import { render, staticRenderFns } from "./AddItemPage.vue?vue&type=template&id=60add1cc&scoped=true&"
import script from "./AddItemPage.vue?vue&type=script&lang=js&"
export * from "./AddItemPage.vue?vue&type=script&lang=js&"
import style0 from "./AddItemPage.vue?vue&type=style&index=0&id=60add1cc&lang=scss&scoped=true&"
import style1 from "./AddItemPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60add1cc",
  null
  
)

export default component.exports